import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SideBarEventService {

  constructor() { }

  private dataIsLoaded: BehaviorSubject<any> = new BehaviorSubject(false);
  currentIsLoaded = this.dataIsLoaded.asObservable();



  toggleIsLoaded(IsLoadedition: any) {
    this.dataIsLoaded.next(IsLoadedition);
  }

}
